import theme from '@app/ui/theme'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 0px;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`

export const ContentCard = styled.div`
  margin: 20px;
  box-shadow: 0 0px 4px 0 ${({ theme }) => theme.colors.dark1};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px;
  border-radius: 4px;
  overflow: scroll;
  height: calc(100% - 100px);
`
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  padding-bottom: 26px;
`
export const FlexBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const CourseContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 15px 0px 0px;
  margin-right: 30px;
`
export const CourseArrayContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 500px;
`

export const CourseName = styled.div`
  display: flex;
  flex-direction: column;
`
export const CourseNameInput = styled.input`
  width: 438px;
  border-radius: 5px;
  border: 1px solid #cecece;
  padding: 8px;
  z-index: 10;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
`

export const HolesCard = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 2px;
`

export const Title = styled.span`
  font-weight: 500;
  font-size: 24px;
`
export const HoleSelection = styled.div`
  width: 385px;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  border: 1px solid #cecece;
  padding: 8px 34px 8px 34px;
  z-index: 10;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
`

export const BottomBar = styled.div`
  width: 100%;
  height: 56px;
  background-color: ${theme.colors.white};
  position: absolute;
  bottom: 0px;
  z-index: 10;
  box-shadow: 0px -1px 5px 2px rgba(0, 0, 0, 0.25);
`

export const GoBackContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`

export const BackArrowContainer = styled.div`
  margin-top: 2px;
`

export const BackText = styled.span`
  margin-left: 10px;
`

// Modal Components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const ModalBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 450px;
  position: relative;
  z-index: 1001;
`

export const ModalTitle = styled.h2`
  margin-top: 0;
  font-size: 22px;
`

export const ModalDescription = styled.p`
  font-size: 16px;
  margin-bottom: 24px;
`

export const ModalButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`

export const CancelButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
`

export const ConfirmButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background-color: ${theme.colors.primary};
  color: white;
  cursor: pointer;
  font-weight: bold;
`

export const DestructiveButton = styled(ConfirmButton)`
  background-color: ${theme.colors.warning};
`

export const VersionOptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 32px;
`

export const VersionOption = styled.label<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${(props) => (props.isSelected ? '#f0f8ff' : 'white')};
`

export const VersionRadio = styled.input`
  margin-right: 12px;
`

export const LatestLabel = styled.span`
  margin-left: 12px;
  background-color: ${theme.colors.primary};
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 12px;
`
